// extracted by mini-css-extract-plugin
export default {"full-table":"style_full-table__rdXeE","table-total":"style_table-total__04efa"};